const storageKeyPrefix = "accounts.cupix.works:";
export const storagableKeys = ["region", "team_domain", "context", "config", "oauth_flow", "identity_provider", "state"];

export const get = (key: string) => {
  const value = localStorage.getItem(`${storageKeyPrefix}${key}`);
  if (value === "undefined") return undefined;
  if (value === "null") return undefined;
  return value;
}

export const search = (pattern: string) => {
  const keys = Object.keys(localStorage);
  const searchKey = keys.find(key => key.includes(pattern));

  if (!searchKey) return undefined;
  return localStorage.getItem(searchKey);
}

export const set = (key: string, value: string) => {
  localStorage.setItem(`${storageKeyPrefix}${key}`, value);
}

export const del = (key: string) => {
  localStorage.removeItem(`${storageKeyPrefix}${key}`);
}

export const clear = () => {
  const keys = Object.keys(localStorage);
  for (const key of keys) {
    console.log(`cleared ${key}`);
  }
  localStorage.clear();
}

const cognitoStorageKeyPrefix = "CognitoIdentityServiceProvider";
export const clearCognitoStorage = () => {
  const keys = Object.keys(localStorage);
  keys.forEach(key => {
    if (key.includes(cognitoStorageKeyPrefix)) {
      console.info(`remove ${key}`);
      localStorage.removeItem(key);
    }
  });
}